import type { SignatureRequest } from '@/_types/models/signatureRequests';
import {
  SIGNATURE_REQUEST_STATUSES,
  type SignatureRequestStatus,
} from '@/_constants/signature-request';

export const getSignatureRequestStatus = (
  signatureRequest: SignatureRequest,
): SignatureRequestStatus => {
  const currentStatus: string = signatureRequest.status;

  return (
    SIGNATURE_REQUEST_STATUSES.find((s) => s.value === currentStatus) ||
    SIGNATURE_REQUEST_STATUSES[0]
  );
};
